interface ErrorResponse {
    code: number;
    message: string;
}

export interface SmartBetsState {
    smartBetsData: any;
    loading: boolean;
    error: ErrorResponse | null;
}


export enum SmartBetsActionTypes {
    FETCH_SMART_BETS_DATA = "FETCH_SMART_BETS_DATA",
    FETCH_SMART_BETS_DATA_SUCCESS = "FETCH_SMART_BETS_DATA_SUCCESS",
    FETCH_SMART_BETS_DATA_ERROR = "FETCH_SMART_BETS_DATA_ERROR",
}

export type SmartBetsAction =
    | { type: SmartBetsActionTypes.FETCH_SMART_BETS_DATA }
    | { type: SmartBetsActionTypes.FETCH_SMART_BETS_DATA_SUCCESS; payload: any[] }
    | { type: SmartBetsActionTypes.FETCH_SMART_BETS_DATA_ERROR; payload: any };